import React from 'react';
import PropTypes from 'prop-types';
import { FlexBox } from '@vp/swan';
import {
  paymentMethodNameMap,
  paymentMethodLogoMap,
} from '../../../constants/paymentMethod';

export const PaymentMethodLogo = ({ paymentMethod, paymentMethodType }) => {
  // If the type is Credit Card, refer to its method (i.e. Visa)
  // For all other types, refer to the type (i.e. ApplePay, PayPal, Credits, etc.)
  const name =
    paymentMethodType === 'CreditCard' ? paymentMethod : paymentMethodType;

  // If payment method cannot be parsed, return nothing
  if (!name || typeof name !== 'string') return null;

  // Get the logo component
  const logo =
    paymentMethodLogoMap[paymentMethodNameMap[name] || name.toLowerCase()];

  if (logo) {
    return (
      <FlexBox
        alignItems="center"
        mr={3}
        data-testid="payment-method-logo"
        style={{
          height: '26px',
          width: '26px',
        }}
      >
        {logo}
      </FlexBox>
    );
  }

  return null;
};

PaymentMethodLogo.propTypes = {
  paymentMethod: PropTypes.string.isRequired,
  paymentMethodType: PropTypes.string.isRequired,
};
